module.exports = __webpack_public_path__ + "img/logo-elastos.e9b90abf.png";